import {
  COMPANY_REMUNERATION_REFERENCE_CONFIG,
  type CompanyRemunerationReferenceContext,
  type CompanyRemunerationReferenceData,
  type CompanyRemunerationReferenceExtraction,
} from "@asap/shared/document/document-types/company-remuneration-reference";
import { CompanyRemunerationReferenceSchemas } from "@asap/shared/schemas/document/document-types/company-remuneration-reference";
import { DocumentTypeHandler } from "../handler";

export const CompanyRemunerationReferenceHandler = new DocumentTypeHandler<
  CompanyRemunerationReferenceExtraction,
  CompanyRemunerationReferenceData,
  CompanyRemunerationReferenceContext
>({
  documentType: COMPANY_REMUNERATION_REFERENCE_CONFIG.documentType,
  documentName: COMPANY_REMUNERATION_REFERENCE_CONFIG.documentName,
  maxFiles: COMPANY_REMUNERATION_REFERENCE_CONFIG.maxFiles,
  acceptedMimeTypes: COMPANY_REMUNERATION_REFERENCE_CONFIG.acceptedMimeTypes,
  requiredFields: COMPANY_REMUNERATION_REFERENCE_CONFIG.requiredFields,
  endpoints: {
    extract: "documents/company-remuneration-reference/extract",
    warn: "documents/company-remuneration-reference/warn",
    verify: "documents/company-remuneration-reference/verify",
    store: "documents/company-remuneration-reference/store",
  },
  schemas: {
    extractResponse: CompanyRemunerationReferenceSchemas.extractResponse,
    warnResponse: CompanyRemunerationReferenceSchemas.warnResponse,
    validateResponse: CompanyRemunerationReferenceSchemas.validateResponse,
    storeResponse: CompanyRemunerationReferenceSchemas.storeResponse,
  },
  toastMessages: {
    success: "L'attestation de rémunération a bien été validée.",
  },
  formFields: [
    {
      key: "expiration_date",
      label: COMPANY_REMUNERATION_REFERENCE_CONFIG.fieldLabels.expiration_date,
      type: "date",
      colSpan: 1,
    },
  ],
  transformExtraction: (
    extraction: CompanyRemunerationReferenceExtraction
  ): Partial<CompanyRemunerationReferenceData> => {
    return {
      expiration_date: extraction.expiration_date,
    };
  },
});
